import { useSuspenseQuery, UseSuspenseQueryResult } from "@tanstack/react-query";
import { fetchCurrentProfile } from "PFCore/services/current_profile";
import { CurrentProfile } from "PFTypes";

import { profileKeys } from "./query_keys";

export const useCurrentProfile = (): UseSuspenseQueryResult<CurrentProfile> =>
  useSuspenseQuery<CurrentProfile>({
    queryKey: profileKeys.me(),
    queryFn: () => fetchCurrentProfile(),
    retry: false
  });
